// extracted by mini-css-extract-plugin
module.exports = {"container":"climbing-status_container_DzhnD","noDataBox":"climbing-status_noDataBox_6cF_S","icon":"climbing-status_icon_YqYwc","chartBox":"climbing-status_chartBox_1r3By"};